import React, { useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
  dateFormatForDatePicker,
  dateFormat,
  MinDate,
  MaxDate,
} from '../../../../../SharedModules/CommonConstants/commonConstants';
import { updatePlanWhenUserUpdateFromCustomComponent } from '../../store/actions';
import { validDate } from '../../../../../SharedModules/CommonUtilities/commonUtilities';

export default (props) => {
  const { column, data, node, rowIndex, value, isEnablebyRole } = props;
  const dispatch = useDispatch();
  const updateValueWhenUserUpdate = (datesGridData) =>
    dispatch(updatePlanWhenUserUpdateFromCustomComponent(datesGridData));
  const plansByCgp = useSelector((state) => {
    return state.sharedState.PlanReducer.plansByCgp;
  });
  const errorMessages = useSelector((state) => {
    return state.sharedState.PlanReducer.planTabData?.errorMessages;
  });
  const handleChangeDate = (d, event) => {
    if (d !== 'Invalid Date') {
      const { colId } = column;
      let values = null;
      const datesGridData = data;
      if (event === 'onBlur' && d.target.value && d.target.value.length > 5) {
        const dateValue = d.target.value.split('/');
        if (dateValue[2].split('_').length === 3) {
          values = moment(d.target.value, 'MM/DD/YY').format(dateFormat);
        } else {
          values =
            d.target.value && d.target.value !== '' ? d.target.value : null;
        }
      } else {
        values = event === 'onBlur' ? d.target.value : d;
      }
      if (
        values !== null &&
        values !== '' &&
        validDate(new Date(values)) === false
      ) {
        updateValueWhenUserUpdate(datesGridData);
        node.setDataValue(colId, values);
        datesGridData.updateRecord = true;
      } else {
        if (
          !(data && data?.oldStartDt && validDate(new Date(data?.oldStartDt)))
        ) {
          datesGridData.oldStartDt = data?.cgpId?.startDt;
        }
        datesGridData.updateRecord = true;
        updateValueWhenUserUpdate(datesGridData);
        node.setDataValue(colId, values);
      }
    }
  };
  console.log({ id: rowIndex });
  return (
    <div data-testid='mfg-bankruptcy-date-picker'>
      {/* <label className='m-0 hide-elm' htmlFor={`${column.colId}_${rowIndex}`}>
        <span>label</span>{' '}
      </label> */}
      {column.colId === 'startDt' ? (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            required
            id={`startDate_${column.colId}_${rowIndex}`}
            data-testid='start-date'
            label={'Start Date'}
            inputProps={{ id: `startDate_${column.colId}_${rowIndex}` }}
            format='MM/dd/yyyy'
            mask='__/__/____'
            minDate={MinDate}
            maxDate={MaxDate}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              readOnly: false,
              autoFill: false,
            }}
            className={
              errorMessages?.length > 0 &&
                (
                  !plansByCgp?.[rowIndex]?.startDt ||
                  plansByCgp?.[rowIndex]?.startDt === 'Invalid date' ||
                  validDate(new Date(plansByCgp?.[rowIndex]?.startDt)) === false
                )
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
            }
            placeholder='mm/dd/yyyy'
            value={value || null}
            onChange={(e) => {
              handleChangeDate(e, 'onChange');
            }}
            onBlur={(e) => {
              handleChangeDate(e, 'onBlur');
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            onKeyDown={async (e) => {
              if (e.keyCode == 67) {
                // copy date
                await window.navigator?.clipboard.writeText(e?.target?.value);
              }
            }}
            helperText={null}
            error={null}
            disabled={!isEnablebyRole}
          />
        </MuiPickersUtilsProvider>
      ) : (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            id={`endDate_${column.colId}_${rowIndex}`}
            data-testid='end-date'
            label={'End Date'}
            inputProps={{ id: `endDate_${column.colId}_${rowIndex}` }}
            format='MM/dd/yyyy'
            mask='__/__/____'
            className={
                plansByCgp?.[rowIndex]?.endDt === 'Invalid date' ||
                  (plansByCgp?.[rowIndex]?.endDt &&
                    validDate(new Date(plansByCgp[rowIndex].endDt)) === false)
                  ? 'td-active-cell tBill-validate frr-display-hidden-label'
                  : 'frr-display-hidden-label'
              }
            InputLabelProps={{
              shrink: true,
            }}
            placeholder='mm/dd/yyyy'
            value={value || null}
            InputProps={{
              readOnly: false,
              autoFill: false,
            }}
            onChange={(e) => {
              handleChangeDate(e, 'onChange');
            }}
            onBlur={(e) => {
              handleChangeDate(e, 'onBlur');
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            helperText={null}
            error
            disabled={!isEnablebyRole}
          />
        </MuiPickersUtilsProvider>
      )}
    </div>
  );
};
